import { DateInput as MantineDateInput } from '@mantine/dates';
import { Calendar } from 'lucide-react';

export const DateInput = MantineDateInput.extend({
	defaultProps: {
		popoverProps: {
			offset: 0,
			classNames: {
				dropdown: 'mantine-DateInput-dropdown',
			},
		},
		leftSection: <Calendar />,
		leftSectionPointerEvents: 'none',
	},
	classNames: {
		levelsGroup: 'mantine-DatePicker-levelsGroup',
		weekday: 'mantine-DatePicker-weekday',
		day: 'mantine-DatePicker-day',
		calendarHeaderLevel: 'mantine-DatePicker-calendarHeaderLevel',
		calendarHeaderControl: 'mantine-DatePicker-calendarHeaderControl',
		calendarHeaderControlIcon: 'mantine-DatePicker-calendarHeaderControlIcon',
		monthsListControl: 'mantine-DatePicker-monthsListControl',
		yearsListControl: 'mantine-DatePicker-yearsListControl',
	},
});
